import {AfterViewInit, Component, NgZone, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {BoService} from './services/bo.service';
import 'jquery';
import * as UI from '@wilout/ui-js';
import {AuthService} from "@auth0/auth0-angular";
import {LogoutService} from "./services/logout.service";
import {ImpersonateDialogComponent, ImpersonateDialogData, ImpersonateDialogDataReturn} from "./popups/impersonate-dialog/impersonate-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {TokenService} from "./services/token.service";
import {MesListesUiService} from "./services/mes-listes-ui.service";
import {filter, take} from 'rxjs/operators';
import {MemberPermissions, memberLandingUrl, readMemberEnablePages} from "./services/member-page-access.policy";

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = 'BO-Wilout-Pay';
  isAdmin = false;
  canImpersonate = false;
  isMember = false;
  isImpersonating = false;
  impersonatedOrganizerName = '';
  sidebarExpanded = false;
  /** Route courante, normalisee, pour l'etat actif du menu lateral. */
  currentUrl = '';
  mesListesOpen = false;
  private mesListesSub?: Subscription;

  constructor(
    private authService: AuthService,
    private boService: BoService,
    private router: Router,
    private ngZone: NgZone,
    private dialog: MatDialog,
    private tokenService: TokenService,
    private logoutService: LogoutService,
    private mesListesUi: MesListesUiService,
  ) {
  }

  ngOnInit() {
    this.cleanupLocalStorage();

    this.mesListesSub = this.mesListesUi.open$.subscribe(() => this.mesListesOpen = true);

    this.currentUrl = this.normalizeUrl(this.router.url);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        $('.blocLoader').fadeIn(0);
      };
      if (event instanceof NavigationEnd) {
        this.currentUrl = this.normalizeUrl(event.urlAfterRedirects);
      }
    });

    // Restore admin status from localStorage if available (for impersonate sessions)
    const storedIsAdmin = localStorage.getItem('isAdmin');
    if (storedIsAdmin === 'true') {
      this.isAdmin = true;
    }
    const storedCanImpersonate = localStorage.getItem('canImpersonate');
    if (storedCanImpersonate === 'true') {
      this.canImpersonate = true;
    }

    // Restore impersonate status from localStorage
    this.isImpersonating = localStorage.getItem('impersonating') === 'true';
    this.impersonatedOrganizerName = localStorage.getItem('impersonatedOrganizerName') || '';

    this.authService.user$
      .pipe(filter(Boolean), take(1))
      .subscribe((user: any) => {
        const roles: string[] = (user as any)?.['https://wilout.com/roles'] || [];
        this.isAdmin = roles.includes('admin') || roles.includes('support');
        this.isMember = roles.includes('member');
        const impersonateRoles = ['admin', 'support', 'partner', 'commercial', 'manager'];
        this.canImpersonate = roles.some(r => impersonateRoles.includes(r));
        const impersonateRole = impersonateRoles.find(r => roles.includes(r)) || '';
        // Persist admin status for impersonate sessions
        localStorage.setItem('isAdmin', this.isAdmin ? 'true' : 'false');
        localStorage.setItem('isMember', this.isMember ? 'true' : 'false');
        localStorage.setItem('canImpersonate', this.canImpersonate ? 'true' : 'false');
        localStorage.setItem('impersonateRole', impersonateRole);
        localStorage.setItem('isCanary', roles.includes('canary') ? 'true' : 'false');
        localStorage.setItem('isStaff', ['admin', 'support', 'commercial', 'manager'].some(r => roles.includes(r)) ? 'true' : 'false');

        // Store original user email (only if not already set - to handle chained impersonates)
        if (!localStorage.getItem('originalUserEmail')) {
          localStorage.setItem('originalUserEmail', user.email);
        }

        this.tokenService.createTokens().then(() => {
          // If impersonating, use the saved organizer ID instead of the admin's email
          const impersonating = localStorage.getItem('impersonating') === 'true';
          const impersonatedOrganizer = localStorage.getItem('impersonatedOrganizer');
          // For members, use the organizer's email from app_metadata
          const appMetadata = (user as any)?.['https://wilout.com/app_metadata'] || {};
          const memberOrganizer = this.isMember ? (appMetadata.emailOrganisateur || '') : '';
          const loginEmail = (impersonating && impersonatedOrganizer) ? impersonatedOrganizer
            : (memberOrganizer || user.email);
          if (this.isMember) {
            localStorage.setItem('memberEmail', user.email);
          }
          this.login(loginEmail);
        }).catch(err => {
          console.error('Token creation failed before login', err);

          // Si c'est une erreur de redirect, c'est normal - la page va recharger
          if (err?.message?.includes('Redirecting to Auth0')) {
            console.log('User being redirected to Auth0 for consent');
            return;
          }

          // Session Auth0 expirée (refresh token invalide)
          const auth0Errors = ['login_required', 'consent_required', 'missing_refresh_token'];
          if (auth0Errors.includes(err?.error) || auth0Errors.includes(err?.message)) {
            console.warn('Auth0 session expired, forcing logout.', err?.error || err?.message);
            this.logoutService.logout();
            return;
          }

          // Si on a atteint le max de tentatives, afficher un message d'erreur
          if (err?.message?.includes('consent failed after')) {
            this.showAuthError('Impossible de se connecter. Veuillez vérifier votre configuration Auth0 ou contacter le support.');
          }
        });
      });

    let t = this;
    $(document).ready(function(){
        console.log('[DEBUG] document.ready triggered');
        // checkTactile désactivé - bloquait la navigation sur les PC avec écran tactile
        var checkTactile=0;
        console.log('[DEBUG] checkTactile =', checkTactile, '| maxTouchPoints =', navigator.maxTouchPoints);
        // Mes listes de contrôle : géré par le composant <app-mes-listes-controle> (refonte wilout/issues#4956)
        $('.addevbtn').click(function(){
            $('.fdpop,.blocaddevent').fadeIn(500);
        });
        $('.decobtn').click(function(){
            $('.fdpop,.bloconfdeco').fadeIn(600);
        });
        $('.fdpop,.closepopadevent').click(function(){
            if(checlic==0){
                $('.blocaddevent').fadeOut(500);
            };
            $('.fdpop,.bloconfdeco').fadeOut(500);
        });
        $('.btnconfdeco,.decobtn2').click(function(){
            $(this).html('Chargement...');
          t.logout()
        });
        $('.bar').focusin(function(){
            $(this).addClass('baron');
            $(this).parent().addClass('boxon');
        });
        $('.bar').focusout(function(){
            $(this).removeClass('baron');
            if($(this).val()!=""){
            }else{
                $(this).parent().removeClass('boxon');
            };
        });
        var dataNewList={
            name:'',
            dateEndValide:''
        };
        var di = new Date();
        var diyear=di.getFullYear();
        var dimonth=(di.getMonth())+1;
        var didate=di.getDate();
        var dihours=di.getHours();
        var diminutes=di.getMinutes();
        var diyearTxt=diyear.toString();
        var dimonthTxt='';if(dimonth<10){dimonthTxt='0'+dimonth.toString()}else{dimonthTxt=dimonth.toString()};
        var didateTxt='';if(didate<10){didateTxt='0'+didate.toString()}else{didateTxt=didate.toString()};
        var dihoursTxt='';if(dihours<10){dihoursTxt='0'+dihours.toString()}else{dihoursTxt=dihours.toString()};
        var diminutesTxt='';if(diminutes<10){diminutesTxt='0'+diminutes.toString()}else{diminutesTxt=diminutes.toString()};
        var dif=diyearTxt+'-'+dimonthTxt+'-'+didateTxt+'T'+dihoursTxt+':'+diminutesTxt;
        $('#indateAE').attr('min',dif);
        $("#innameAE").keyup(function(){
            dataNewList.name=$(this).val();
        });
        $("#innameAE").change(function(){
            $(this).removeClass('signalinvide').attr('placeholder','Titre');
        });
        $('#indateAE').change(function(){
            if($(this).val()!=''){
                var vd=$(this).val().split('T');
                var vd1=vd[0].split('-');
                vd1=vd1[2]+'-'+vd1[1]+'-'+vd1[0];
                var vd2=vd[1]+':00';
                dataNewList.dateEndValide=vd1+' '+vd2;
            };
            $(this).removeClass('signalinvide');
        });
        var checlic=0;
        $('.btnconfaddevent').click(function(event){
            event.stopPropagation();
            if(checlic==0){
                checlic=1;
                var checkobl=0;
                var re=/^[ t]*$/;
                if(dataNewList.name==''||dataNewList.name.match(re)){$('#innameAE').addClass('signalinvide').attr('placeholder','Ce champ est requis');checlic=0;checkobl=1};
                if(dataNewList.dateEndValide==''){$('#indateAE').addClass('signalinvide');checlic=0;checkobl=1};
                if(checkobl==0){
                    $(this).addClass('btnconfaddeventLoad');
                    $('.labelconfaddevent').html('<i class="fa-regular fa-hourglass-start"></i> &nbsp;Chargement ...');
                    $('.loaderaddevent').addClass('loaderaddeventActive');
                    t.boService.createList(dataNewList).then((data) => {
                        var idevent = data['message'].id;
                        t.boService.getAllLists(idevent).then((data) => {
                            createOk();
                        }).catch(error => {
                            console.log('Erreur de chargement des données events ( '+error+' )');
                            checlic=0;resetSaveBtn();
                        });
                    }).catch(error => {
                        console.log('Erreur de création d\'un événement ( '+error.error.message+' )');
                        checlic=0;resetSaveBtn();
                    });
                };
            };
        });
        /** Remet le bouton d'enregistrement dans son etat initial. */
        function resetSaveBtn(){
            $('.btnconfaddevent').removeClass('btnconfaddeventLoad');
            $('.labelconfaddevent').html('<i class="fas fa-save"></i> &nbsp;Enregistrer');
            $('.loaderaddevent').removeClass('loaderaddeventActive');
        };
        function createOk(){
            $('.headae').fadeIn(0);
            dataNewList={
                name:'',
                dateEndValide:''
            };
            $('.inae').removeClass('signalinvide');
            $('#innameAE').val('').attr('placeholder','Titre');
            $('#indateAE').val('');
            resetSaveBtn();
            $('.fdpop,.fdpopstop,.blocaddevent').fadeOut(300);
            checlic=0;
            t.boService.reloadRoute('/tableau-de-bord');
        };
    });
  };

  ngAfterViewInit() {
    UI.init();
  }

  ngOnDestroy() {
    this.mesListesSub?.unsubscribe();
    UI.destroy();
  }

  /** Ouvre le slide-over "Mes listes de contrôle" (canal unique partagé avec le dashboard). */
  openMesListes() {
    this.mesListesUi.open();
  }

  toggleSidebar() {
    this.sidebarExpanded = !this.sidebarExpanded;
  }

  navigateTo(url: string) {
    this.ngZone.run(() => this.router.navigateByUrl(url));
  }

  // ── Etat actif du menu lateral ─────────────────────────────────────────────

  /** Retire query string et fragment : /aide?x=1#y et /aide designent la meme page. */
  private normalizeUrl(url: string): string {
    return (url || '').split('?')[0].split('#')[0];
  }

  /** Vrai si la route passee est la page courante (lien de sous-menu). */
  isRouteActive(route: string): boolean {
    return this.currentUrl === route;
  }

  /** Vrai si l'une des routes de la section est la page courante (entree parente). */
  isSectionActive(...routes: string[]): boolean {
    return routes.some(r => this.isRouteActive(r));
  }

  // Page d'atterrissage d'un member après login : 1re page autorisée, sinon page
  // neutre /mes-informations (jamais /tableau-de-bord en dur — cf. ticket #4965, le
  // MemberPageGuard bouclerait si tableau-de-bord n'est pas dans enablePages).
  // Source de vérité = localStorage.memberPermissions, comme le guard.
  // Wrapper distinct de la fonction pure memberLandingUrl(pages) importée : lit
  // les permissions puis délègue. Policy partagée avec MemberPageGuard (#4965).
  private resolveMemberLandingUrl(): string {
    return memberLandingUrl(readMemberEnablePages());
  }


  login(email, forceNavigate = false) {
    this.resetFirstListUI();
    const isMember = localStorage.getItem('isMember') === 'true';

    this.boService.signIn(email).then((data) => {
      localStorage.setItem('authUser', 'true');
      localStorage.setItem('idUser', JSON.stringify(data['user']['user']['_id']));
      localStorage.setItem('infoUser', JSON.stringify(data['user']['user']));
      $('.loaderlogin').animate({'width': '80%'}, 2500);

      // For members: load permissions FIRST, then load lists (no race condition)
      const permissionsReady = isMember
        ? this.boService.getMemberPermissions(localStorage.getItem('memberEmail') || email)
            .then((perms: any) => {
              localStorage.setItem('memberPermissions', JSON.stringify({
                enableList: perms.enableList || [],
                enablePages: perms.enablePages || []
              }));
            })
            // Membre bloqué par l'organisateur (403, #8627) : aucune liste ni page. Pas
            // enableList vide seul, qui voudrait dire « toutes les listes de l'organisateur ».
            // Les autres échecs gardent la forme stockée existante.
            .catch((error) => {
              const noPermissions: MemberPermissions = {enableList: [], enablePages: []};
              const stored: MemberPermissions = error?.status === 403 ? {...noPermissions, accessDenied: true} : noPermissions;
              localStorage.setItem('memberPermissions', JSON.stringify(stored));
            })
        : Promise.resolve();

      permissionsReady.then(() => {
        let checkstorage = localStorage.getItem('dataList');
        var idevent = '0';
        if (checkstorage != undefined && checkstorage != '') {
          idevent = JSON.parse(checkstorage)['_id'];
        }
        this.boService.getAllLists(idevent).then((lc) => {
          const impersonating = (localStorage.getItem('impersonating') === 'true');
          if (Object.keys(lc).length == 0) {
            if (isMember) {
              // Member sans liste : atterrir sur sa 1re page autorisée, sinon page neutre.
              // Surtout pas /tableau-de-bord en aveugle (boucle guard #4965).
              this.boService.reloadRoute(this.resolveMemberLandingUrl());
            } else {
              // Organizer with no lists — show "create first list" UI
              $('.bloclog').fadeOut(400);
              $('.headae').fadeOut(0);
              $('.fdlog').css({'background-position': '99%'});
              $('.titfirstev').html('<span style="font-size:25px;"><i class="far fa-clipboard-check"></i> &nbsp;Créez votre première liste de contrôle</span>').css({'color': 'var(--ui-color-white)'});
              $('.bottomae').css({'top': '440px'});
              $('.blocaddevent').css({'height': '440px'}).fadeIn(400);
              try {
                localStorage.setItem('impersonating', '');
                localStorage.setItem('impersonatedOrganizer', '');
              } catch (e) {}
            }
          } else if (impersonating || forceNavigate || isMember) {
            // Navigation post-login : un member va sur sa 1re page autorisée (le dashboard
            // peut ne pas faire partie de ses pages) ; organizer/impersonate -> dashboard.
            this.boService.reloadRoute(isMember ? this.resolveMemberLandingUrl() : '/tableau-de-bord');
          }
        }).catch(error => {
          console.log('Erreur de chargement des listes de contrôle ( ' + error + ' )');
          $('.loaderlogin').css({'width': 0});
          this.resetFirstListUI();
          if (isMember) {
            // Member error — stay on app, don't redirect to BO Online
            console.error('Member: impossible de charger les listes');
          } else {
            this.ngZone.run(() => this.router.navigateByUrl('/redirect-to-bo-online'));
          }
        });
      });
    }).catch(error => {
      console.log(error);
      $('.loaderlogin').css({'width': 0});
    });
  }

  logout() {
    this.resetFirstListUI();
    this.isImpersonating = false;
    this.impersonatedOrganizerName = '';
    this.logoutService.logout();
  }

  exitImpersonate() {
    // Get the original user email stored at first impersonate
    const originalEmail = localStorage.getItem('originalUserEmail');

    if (!originalEmail) {
      console.error('No original user email found, cannot exit impersonate');
      return;
    }

    this.resetFirstListUI();

    // Clear impersonate state but keep originalUserEmail for potential re-impersonate
    localStorage.setItem('impersonating', '');
    localStorage.setItem('impersonatedOrganizer', '');
    localStorage.setItem('impersonatedOrganizerName', '');
    // Clear stale data
    localStorage.setItem('dataList', '');
    localStorage.setItem('dataAllLists', '');

    // Reset component state
    this.isImpersonating = false;
    this.impersonatedOrganizerName = '';

    // Login with the original user email and force navigation to dashboard
    this.login(originalEmail, true);
  }

  onImpersonate() {
    const dialogRef = this.dialog.open<ImpersonateDialogComponent, ImpersonateDialogData, ImpersonateDialogDataReturn>(ImpersonateDialogComponent, {
      width: '400px',
      data: {email: ''} as ImpersonateDialogData
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        try {
          localStorage.setItem('impersonating', 'true');
          localStorage.setItem('impersonatedOrganizer', result.organizer);
          localStorage.setItem('impersonatedOrganizerName', result.organizerName || result.organizer);
          // Clear previous org data to avoid filtering by wrong event ID
          localStorage.setItem('dataList', '');
          localStorage.setItem('dataAllLists', '');
        } catch (e) { }
        // Update component state
        this.isImpersonating = true;
        this.impersonatedOrganizerName = result.organizerName || result.organizer;
        this.login(result.organizer);
      }
    });
  }

  isPageAllowed(page: string): boolean {
    // Lecture des permissions consolidée via la policy (#4965) — même contrat
    // enablePages que MemberPageGuard. Comportement inchangé (pas d'always-allowed ici).
    return !this.isMember || readMemberEnablePages().includes(page);
  }

  private resetFirstListUI() {
    try {
      $('.bloclog').show();
      $('.headae').show();
      $('.fdlog').css({'background-position': ''});
      $('.titfirstev').css({'color': ''});
      $('.bottomae').css({'top': ''});
      $('.blocaddevent').hide().css({'height': ''});
      $('.fdpop,.bloconfdeco,.fdpopstop').hide();
      $('.loaderlogin').css({'width': 0});
    } catch (e) { /* noop */
    }
  }

  private cleanupLocalStorage() {
    const keysToClean = ['idUser', 'infoUser', 'dataList', 'dataAllLists'];
    keysToClean.forEach(key => {
      const value = localStorage.getItem(key);
      if (value === 'undefined' || value === 'null') {
        localStorage.setItem(key, '');
      }
    });
  }

  private showAuthError(message: string) {
    try {
      console.error('Auth Error:', message);
      alert(message);
      this.authService.logout();
    } catch (e) {
      console.error('Failed to show auth error', e);
    }
  }
}
